/**
 * @fileoverview Application Initializer
 * Initializes core services including ConsentManager and AnalyticsService
 * Ensures proper integration between consent management and analytics
 */

import { useEffect } from 'react';
import ConsentManager from '../services/consent/ConsentManager';
import AnalyticsService from '../services/analytics/AnalyticsService';
import { GA4_TRACKING_ID } from '../types/analytics.types';
import { initializeOutboundLinkTracking } from '../utils/outboundLinkTracker';

/**
 * AppInitializer Component
 * Initializes services when the app starts
 */
const AppInitializer = ({ children }) => {
  useEffect(() => {
    // Initialize ConsentManager first (sets default consent mode)
    ConsentManager.initialize();
    
    // Initialize AnalyticsService with GA4 tracking ID
    AnalyticsService.initialize(GA4_TRACKING_ID);
    
    // Initialize automatic outbound link tracking
    initializeOutboundLinkTracking();
    
    // Log initialization (only in development)
    if (process.env.NODE_ENV === 'development') {
      console.log('App services initialized');
      console.log('Consent status:', ConsentManager.hasConsent());
      console.log('Analytics consent:', ConsentManager.hasAnalyticsConsent());
    }
  }, []);

  return children;
};

export default AppInitializer;
